/**
 * UnauthenticatedPage - Full page layout for unauthenticated users.
 * Provides a consistent "Sign in to get started" experience across the app.
 */

import * as React from 'react';
import { useTranslation } from 'react-i18next';
import { PageLayout } from '@/components';
import { SignInPrompt } from './sign-in-prompt';

export interface UnauthenticatedPageProps {
  /** Page title displayed above the sign-in prompt */
  title?: string;
  /** Description text below the title */
  description?: string;
  /** Icon to display in the prompt */
  icon?: React.ReactNode;
  /** Additional content to show below the sign-in prompt */
  children?: React.ReactNode;
}

const UnauthenticatedPage = React.forwardRef<HTMLDivElement, UnauthenticatedPageProps>(
  (
    {
      title,
      description,
      icon,
      children,
    },
    ref
  ) => {
    return (
      <PageLayout>
        <div ref={ref} className="max-w-3xl mx-auto px-6 py-12">
          <SignInPrompt
            icon={icon}
            title={title}
            description={description}
          />
          {children}
        </div>
      </PageLayout>
    );
  }
);
UnauthenticatedPage.displayName = 'UnauthenticatedPage';

export { UnauthenticatedPage };
